<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="info"></ng-container>
        <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </tt-card>

    <div class="col-xs-12 sp-0" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_info">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_functions">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="metatable_keyno" [ttModel]="menu.metatable_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="metatable_name" [ttModel]="menu.metatable_name" ttReadonly></tt-input>
        <tt-input ttLabel="metatable_table_name" [ttModel]="menu.metatable_table_name" ttReadonly></tt-input>
        <tt-select ttLabel="table_name_related_to" [ttModel]="menu.table_name_related_to" [ttData]="selectListRelatedTo" ttDataId="table_name_related_to" ttDataName="table_name_related_to_name" ttReadonly></tt-select>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!menu">
        <tt-button-goto [ttText]="'metatablemenu_edit'" [ttGoto]="'metatable'" [ttGotoParms]="{ metatable_keyno: menu.metatable_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'metatablemenu_metacolumns'" [ttBadge]="menu.nbr_of_columns" [ttGoto]="'metacolumns'" [ttGotoParms]="{ metatable_keyno: menu.metatable_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'metatablemenu_metatableviews'" [ttGoto]="'metatableviews'" [ttGotoParms]="{ metatable_keyno: menu.metatable_keyno }"></tt-button-goto>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-input class="col-xs-12 sp-0" tt-label="metatable_keyno" tt-model="vm.model.menu.metatable_keyno" tt-change="vm.model.menu.metatable_keyno = $value" tt-readonly="true"></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="metatable_name" tt-model="vm.model.menu.metatable_name" tt-change="vm.model.menu.metatable_name = $value" tt-readonly="true"></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="metatable_table_name" tt-model="vm.model.menu.metatable_table_name" tt-change="vm.model.menu.metatable_table_name = $value" tt-readonly="true"></tt-input>
            <tt-select class="col-xs-12 sp-0" tt-label="table_name_related_to" tt-model="vm.model.menu.table_name_related_to" tt-change="vm.model.menu.table_name_related_to = $value" tt-data="vm.model.selectListRelatedTo" tt-data-id="table_name_related_to" tt-data-name="table_name_related_to_name" tt-readonly="true"></tt-select>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-button-goto class="col-xs-12 sp-0" tt-text="metatablemenu_edit" tt-goto="metatable" tt-goto-parms="{ metatable_keyno: vm.model.menu.metatable_keyno }" tt-text-align="left"></tt-button-goto>
            <tt-button-goto class="col-xs-12 sp-0" tt-text="metatablemenu_metacolumns" tt-badge="{{vm.model.menu.nbr_of_columns}}" tt-goto="metacolumns" tt-goto-parms="{ metatable_keyno: vm.model.menu.metatable_keyno }" tt-text-align="left"></tt-button-goto>
            <tt-button-goto class="col-xs-12 sp-0" tt-text="metatablemenu_metatableviews" tt-goto="metatableviews" tt-goto-parms="{ metatable_keyno: vm.model.menu.metatable_keyno }" tt-text-align="left"></tt-button-goto>
        </tt-card>
    </div>
</tt-page>-->
